define('ThemesHelper', [],function () {
  var ThemesHelper = {
    COOKIE_NAME: 'md_theme',
    COOKIE_EXPIRATION_DAYS: 365,
    THEME_URI_SUFFIX: '/globals/src/',
    THEME_SUFFIX: '/landings/src/',
    AVAILABLE_THEMES: ['classicTheme', 'newTheme', 'v2', 'v3', 'vEmBlue'],
    DEFAULT_THEME: 'vEmBlue',
    THEME_LOADING_FLAG: 'theme-loading',
    THEME_LOADED_FLAG: 'ui-ready',

    addLoadingThemeFlag: function () {
      $('body').addClass(ThemesHelper.THEME_LOADING_FLAG);

      return this;
    },

    getScaleClass: function () {
      const scale = window.devicePixelRatio * 100;

      return 'scale_' + scale;
    },

    addingThemeClasses: function () {
      $('body')
        .removeClass(ThemesHelper.THEME_LOADING_FLAG)
        .addClass(ThemesHelper.THEME_LOADED_FLAG)
        .addClass('_' + THEME.CURRENT_THEME)
        .addClass(ThemesHelper.getScaleClass())
        .css('visibility', 'visible');

      return this;
    },

    addThemeStylesheet: function () {
      var globalStylesheetURL = this.getGlobalThemeStylesheetURL(),
        customStylesheetURL = this.getCustomThemeStylesheetURL();

      this.addLoadingThemeFlag().loadCssFiles(
        [globalStylesheetURL, customStylesheetURL],
        this.addingThemeClasses
      );
    },

    loadCssFiles: function (urls, successCallback, failureCallback) {
      $.map(urls, function (url) {
        // Ugly, but avoid CORS error (jQuery version)
        // If this is a problem, we can go further with MutationObserver: https://stackoverflow.com/a/38171848
        $('head').append('<link rel="stylesheet" type="text/css" href="' + url + '">');
      });

      setTimeout(function () {
        if (typeof successCallback === 'function') successCallback();
      }, 1000);
    },

    getGlobalThemeStylesheetURL: function () {
      return this.getCurrentThemeGlobalURL() + 'styles/styles.css';
    },

    getCustomThemeStylesheetURL: function () {
      return this.getCurrentThemeURL() + 'styles/styles.css';
    },

    getCurrentTheme: function () {
      if (THEME.CURRENT_THEME && THEME.CURRENT_THEME !== 'undefined') {
        return THEME.CURRENT_THEME;
      } else {
        return this.DEFAULT_THEME;
      }
    },

    setNewTheme: function (theme) {
      THEME.CURRENT_THEME = theme;
    },

    getCurrentThemeGlobalURL: function () {
      return THEME.ASSETS_URL + THEME.CURRENT_THEME + this.THEME_URI_SUFFIX;
    },

    getCurrentThemeURL: function () {
      return THEME.ASSETS_URL + THEME.CURRENT_THEME + this.THEME_SUFFIX;
    },

    getCookie: function (cname) {
      var name = cname + '=',
        decodedCookie = decodeURIComponent(document.cookie),
        ca = decodedCookie.split(';');

      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
          if (c.substring(name.length, c.length) !== 'null') {
            return c.substring(name.length, c.length);
          } else {
            return null;
          }
        }
      }
      return '';
    },

    checkThemeGlobalVar: function (config) {
      if (window.THEME === undefined) {
        window.THEME = {
          ASSETS_URL: config.themeAssetsUrl || '',
          THEME_URL: '',
          CURRENT_THEME: '',
          COOKIE_DOMAIN: config.i18nCookieDomain,
        };
      }
    },

    buildThemeCookieExpirationDate: function () {
      var d = new Date();
      d.setTime(d.getTime() + this.COOKIE_EXPIRATION_DAYS * 24 * 60 * 60 * 1000);

      return 'expires=' + d.toUTCString();
    },

    setCookieTheme: function (theme) {
      document.cookie =
        this.COOKIE_NAME +
        '=' +
        theme +
        ';' +
        this.buildThemeCookieExpirationDate() +
        '; path=/;Domain=' +
        THEME.COOKIE_DOMAIN +
        '; samesite=None; Secure;';
    },

    setConfig: function (config) {
      this.checkThemeGlobalVar(config);
    },

    addThemeClass: function (userTheme) {
      $('body').removeClass(this.AVAILABLE_THEMES.join(' ')).addClass(userTheme);
    },

    initUserTheme: function (theme) {
      var cookieTheme = this.getCookie(this.COOKIE_NAME),
        userTheme = this.DEFAULT_THEME;

      this.addThemeClass(userTheme);
      this.setNewTheme(userTheme);
      this.addThemeStylesheet();

      if (!cookieTheme) {
        this.setCookieTheme(userTheme);
      }
    },
  };

  return ThemesHelper;
});

